export default __webpack_public_path__ + "static/media/no-hint.2b127c57.ogg";